import { Component, Input, OnInit } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { LogoTypeEnum } from '~/component/logo/enums/logo-type.enum';

@Component({
  selector: 'app-basic-header-layout',
  templateUrl: './basic-header.component.html',
  styleUrls: ['./basic-header.component.scss'],
})
export class BasicHeaderLayoutComponent implements OnInit {
  @Input() public logo: LogoTypeEnum;
  @Input() public logoAlt: string;

  public homeLink: string;

  constructor(private readonly localizeRouterService: LocalizeRouterService) {}

  public ngOnInit(): void {
    this.homeLink = this.localizeRouterService.translateRoute('/').toString();
  }
}
